<div class="copilot-wizard-tile-wrapper">
    <div class="copilot-wizard-tile-container"
        [style.height]="isExpiredUser ? '130px' : null"
        [style.justify-content]="!isExpiredUser ? 'center' : null"
        [class.disabled]="isExpiredUser"
        (mouseenter)="(isHovered = true)"
        (mouseleave)="(isHovered = false)">
        <app-coming-soon class="coming-soon-tooltip" [isVisible]="isHovered && isComingSoon"/>
        <img [src]="iconPath" alt="copilot-wizard-tile-1" class="copilot-wizard-tile-icon">
        <div class="copilot-wizard-tile-title"> {{ title }} </div>
        <div class="copilot-wizard-tile-description"> {{ description }} </div>
    </div>
    @if (isExpiredUser) {
        <div class="premium-overlay">
            <span class="text">Upgrade to unlock</span>
            <div class="icon"> <img [src]="'svg/crown.svg' | assetVersion"> </div>
        </div>
    }
</div>